var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper d-flex flex-column vh-100"},[_c('div',{staticClass:"pc_main_area",attrs:{"id":_vm.getId()}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }